<template>
    <div>
        <div class="title">
            {{ `${room.parkName}${room.floorName}${room.houseNum}` }}
        </div>
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 20px"
        >
            <Select
                style="width: 100px; margin-right: 15px"
                v-model="filter.rentType"
                placeholder="房源操作"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in dict.rentType.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="350"
        >
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="row.rentType !== '1' && row.rentType !== '2'"
                    type="default"
                    size="small"
                    @click="rowGoods(row)"
                >
                    物品清单
                </Button>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            placement="top"
            @change="fetch"
        ></table-pager>
        <!-- 弹出框 -->
        <smart-modal
            v-model="modal.showFListForm"
            title="物品清单"
            :width="800"
            :height="500"
            :maskClosable="false"
        >
            <f-list-form v-if="modal.showFListForm" :id="curId" />
        </smart-modal>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import Dict from '_u/dict'
import { deepCopy } from '_u/helper'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import { ymd } from '_u/helper'

import FListForm from './f-list-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { assetsRentalRecords } from '@/api/assets'

const PAGE_SIZE = 20

export default {
    name: 'RentalList',

    props: {
        room: {
            type: Object,
            default: () => ({}),
        },
    },

    components: { FListForm, FilterDateRange },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            loading: false,
            curId: '',
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                houseId: this.room.id,
                rentType: '',
                startDate: '',
                endDate: '',
            },
            page: {
                total: 0,
                list: [],
            },
            modal: {
                showFListForm: false,
            },
            dict: {
                rentType: Dict.NULL,
            },
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 70,
                },
                {
                    key: 'createTime',
                    title: '操作时间',
                    align: 'center',
                    minWidth: 160,
                    tooltip: true,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'cusName',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 100,
                },

                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'rentType',
                    title: '房源操作',
                    align: 'center',
                    minWidth: 90,
                    render: mapCell(this.dict.rentType.toList()),
                },
                // checkInTime
                {
                    key: 'checkInTime',
                    title: '入住时间',
                    align: 'center',
                    minWidth: 180,
                    tooltip: true,
                },
                {
                    key: 'remark',
                    title: '备注',
                    align: 'left',
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    minWidth: 120,
                    slot: 'action',
                },
            ]
        },
    },

    methods: {
        fetch() {
            this.loading = true
            Promise.all([assetsRentalRecords(this.filter)])
                .then((args) => {
                    var [page] = args

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            let list = data.page.list
            list.forEach((i) => {
                if (i.rentStartDate && i.rentEndDate) {
                    i.checkInTime = `${i.rentStartDate} - ${i.rentEndDate}`
                } else if (i.rentStartDate !== null && i.rentEndDate == null) {
                    i.checkInTime = `${i.rentStartDate} - 至今`
                } else {
                    i.checkInTime = ''
                }
            })
            // console.log(list);
            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },

        // 物品清单
        rowGoods(row) {
            this.curId = row.contractId
            this.modal.showFListForm = true
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '关闭', name: 'cancel' }]

        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            this.loading = true
            Promise.all([
                Dict.get(['rent_type']),
                assetsRentalRecords(this.filter),
            ])
                .then((args) => {
                    var [dictGroup, page] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped>
.title {
    font-size: 18px;
    text-align: left;
    color: #555555;
    margin-bottom: 10px;
}
</style>
